import { Component } from '@angular/core';

@Component({
  selector: 'aig-textgroup',
  imports: [],
  templateUrl: './textgroup.component.html',
  styleUrl: './textgroup.component.scss'
})
export class TextgroupComponent {

}
